import React from "react";
import Dialog from "@material-ui/core/Dialog"; 
import DialogContentText from "@material-ui/core/DialogContentText";
import Grid from "@material-ui/core/Grid";
import DialogContent from "@material-ui/core/DialogContent"; 
import Slide from "@material-ui/core/Slide";
import useMediaQuery from "@material-ui/core/useMediaQuery"; 
//Spinner
import ReactLoading from "react-loading";
//STYLES
import { useTheme } from "@material-ui/core/styles";
import useStyles from "./style.js";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function LoadUser(props) {
  
  const { height=200, width=200 } = props;
  const classes  = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={true}    
      fullScreen={fullScreen}
      fullWidth 
      maxWidth="md" 
      TransitionComponent={Transition}
      className={classes.root}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      BackdropProps={{
        classes: {
          root: classes.backdrop,
        },
      }}
      PaperProps={{
        classes: {
          root: classes.paper,
        },
      }}
    >
    
      <DialogContent dividers className={classes.content}>
        <Grid container direction="row" justify="space-evenly" alignItems="stretch" className={classes.other}>
            <Grid item container direction="row" justify="center" alignItems="center">
              <ReactLoading type="spinningBubbles" color="#86bbd8" height={height} width={width}/>
            </Grid>
          <DialogContentText gutterBottom className={classes.contentText} variant="h4">
            {'Cargando...'}
          </DialogContentText>
        </Grid> 
      </DialogContent> 
    </Dialog>
  );
}












 
 
  
 
